import React, { useState, useEffect } from "react";
import { Box, Typography, Container } from "@mui/material";

const Greeting = () => {
  const date = new Date();
  const hours = date.getHours();
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  let month = months[date.getMonth()];
  let today = `${date.getUTCDate()} ${month} ${date.getFullYear()}`;

  let greeting = 
    hours < 12 ? "Good morning" :
    hours < 18 ? "Good afternoon" :
    hours < 21 ? "Good evening" : "Good night";

  const [firstName, setFirstName] = useState("");
  const token = localStorage.getItem("access_token");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/profile`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (!response.ok) throw new Error(`Failed to fetch: ${response.statusText}`);

        const data = await response.json();
        setFirstName(data.user.fname || "");
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchProfile();
  }, [token]);

  return (
    <Box py={3} px={4} sx={{ maxWidth: "1300px", mx: "auto" }}>
      <Container maxWidth="lg" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="h3" sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}>
          👋
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography variant="h4" sx={{ fontWeight: "bold", fontSize: { xs: "1.2rem", sm: "1.8rem" } }}>
              {greeting}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: "bold", fontSize: { xs: "1.2rem", sm: "1.8rem" } }}>
              {firstName}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Greeting;